import { createSlice } from "@reduxjs/toolkit";


export const initialState = {
  currentPage:'Bot threads',
  inner_side_value:''
};

const loginSlice = createSlice({
  name: "SideBarCust",
  initialState,
  reducers: {
    
    change_page(state,action){
          state.currentPage=action.payload 
    },

    change_inner_side_bar_visibility(state,action){
      state.inner_side_value = action.payload
    }
  },
});

export const {
    change_page,
    change_inner_side_bar_visibility
} = loginSlice.actions

export default loginSlice.reducer;